/*------------------------------------------------
// File Name:PDM_MA_Appt.js
// File Description:PDM_MA_Appt store方法
// Author:zxl
// Create Time:2023/08/01 16:27:29
//------------------------------------------------*/

import {
    GetPDM_MA_ApptList,
    GetPDM_MA_ApptListByPage,
    GetPDM_MA_ApptEntity,
    CreatePDM_MA_ApptEntity,
    UpdatePDM_MA_ApptEntity,
    DeletePDM_MA_ApptEntity,
} from '@/api/pdm/ma/maAppt'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaAppt = {
    namespaced: true,
    state: {
        PdmMaApptList: [],
        PdmMaApptListLoading: false,
        PdmMaApptEntity: null,
        PdmMaApptShowDlg: false,
        PdmMaApptYuYueCount:0,
    },
    mutations: {
        setPdmMaApptYuYueCount(state, data) {
            state.PdmMaApptYuYueCount = data
        },
        setPdmMaApptList(state, dataList) {
            state.PdmMaApptList = [...dataList]
        },
        setPdmMaApptListLoading(state, visible) {
            state.PdmMaApptListLoading = visible
        },
        setPdmMaApptShowDlg(state, visible) {
            state.PdmMaApptShowDlg = visible
        },
        setPdmMaApptEntity(state, entity) {
            state.PdmMaApptEntity = entity
        },
    },
    actions: {
        //创建预约信息对象
        actCreatePdmMaAppt({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_ApptEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaApptEntity', res.Data)
                        commit('setPdmMaApptShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约信息对象
        actGetPdmMaApptEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaApptListLoading', true)
                GetPDM_MA_ApptEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaApptEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaApptListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约信息列表
        actGetPdmMaApptList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaApptListLoading', true)
                GetPDM_MA_ApptList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaApptList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaApptListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载预约信息列表
        actGetPdmMaApptListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaApptListLoading', true)
                GetPDM_MA_ApptListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaApptList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaApptListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存预约信息信息
        actUpdatePdmMaAppt({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_ApptEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaApptShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Appt
        actEditPdmMaApptData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaApptID : entity.PdmMaApptID
                }
                GetPDM_MA_ApptEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaApptEntity', res.Data)
                        commit('setPdmMaApptShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Appt ,传对象过来
        actEditPdmMaAppt({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaApptEntity', entity)
                commit('setPdmMaApptShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Appt
        actDeletePdmMaAppt({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前预约信息？").onOk(() => {
                    DeletePDM_MA_ApptEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaApptShowDlg', false)
                           
                            msg.success("删除预约信息成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除预约信息失败，原因:" + res.Message)
                            //msg.success("删除预约信息失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


